import { render } from "./TheCarousel.vue?vue&type=template&id=f241b7b2"
const script = {}

import "./TheCarousel.vue?vue&type=style&index=0&id=f241b7b2&lang=css"

import exportComponent from "C:\\Users\\knhmb\\Documents\\Khalid\\Job\\MarvelConnect Technology\\Projects\\One Shop Online Shopping\\one-shop-online-shopping\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__